import { Meta } from './common'

export enum QuestionType {
  text = "text",
  single_choice = "single_choice",
  multiple_choice = "multiple_choice",
  CaseStudy = 'case_study',
}

export interface QuestionResponse {
  data: QuestionDetail[]
  meta: Meta
}

export interface QuestionDetail {
  text?: string
  question_info?: string
  question_text?: string
  total_sub_questions?: number
  sub_questions: SubQuestion[]
  question_id: number
  moodle_question_id: string
  ai_marks?: number
  tutor_marks?: number
  avg_ai_marks?: number
  avg_tutor_marks?: number
  chapter?: string
  chapters?: string[]
  section?: QuestionSection
  createdAt: string | number | Date
  updatedAt: string | number | Date
}

export interface Question {
  id: string
  question: QuestionDetail
  createdAt: string | number | Date
}

export enum QuestionSection {
  A = 'A',
  B = 'B',
  C = 'C'
}

export interface QuestionParams {
  page: number
  size: number
}

export enum QuestionListType {
  text='text',
  choice='choice',
  non_case_study = 'non_case_study',
  case_study = 'case_study',
}

export interface QuestionListBody {
  module_id?: number
  chapter_id?: string
  chapter_ids?: string[]
  query?: string
  section?: QuestionSection
  type?: QuestionListType
}

export interface CaseStudyParams {
  module_id: number
  section: QuestionSection
  search: string
  page: number
  size: number
}

export interface CaseStudyResponse {
  case_study_id: number
  content?: string
  case_study?: string
  total_questions: number
  total_duration: number
  total_mark: number
}

export interface CaseStudyListResponse {
  data: CaseStudyResponse
  meta: Meta
}

export interface CaseStudyQuestion {
  question_id: number
  question_info: string
  moodle_question_id: string
  text: string
  section: string
  chapter_name: string[]
  sub_questions: number
  time: number
  marks: number
  avg_ai_marks?: number
  avg_tutor_marks?: number
  created_at: string
  updated_at: string
}

export interface CaseStudyQuestionListResponse {
  case_study_id: number
  case_study_content: string
  // Backend may return either `questions` or `question`
  questions?: CaseStudyQuestion[]
  question?: CaseStudyQuestion[]
}

export interface MarkingScheme {
  markingSchemeLevelId: number;
  level: number;
  markRange: string;
  description: string;
  rubric: string;
}

export interface SubQuestionOption {
  option_id: number
  text: string
  is_correct: boolean
}

export interface SubQuestion {
  sub_question_id?: number
  text?: string
  time_limit: number
  marks: number
  options: SubQuestionOption[]
  type: QuestionType
  markingScheme: MarkingScheme[];
  subQuestionAnswerText?: string;
  subQuestionOptionAnswers?: number[];
  subQuestionAnswerSheetLink?: string;
  subQuestionAnswerSheetLinkData?: SheetData[];
  chapters?: string[]
}

export interface SheetData {
  tab_name: string;
  data: string;
}